import { useState } from "react";
import {
  Users,
  UserPlus,
  UserRoundCheck,
  UserRoundX,
  Search,
  Filter,
  ArrowUpDown,
  Download,
  Phone,
  MessageSquare,
  MoreVertical,
} from "lucide-react";
import MainLayout from "../sidebar/Sidebar.js";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const DesignReplicaMobile = () => {
  const [location, setLocation] = useState("DesignReplica");
  const [searchTerm, setSearchTerm] = useState("");

  const metrics = [
    {
      title: "Total Leads",
      value: "82",
      subtitle: "+4 vs last week",
      icon: <Users className="w-4 h-4 text-gray-600" />,
    },
    {
      title: "New Leads",
      value: "18",
      subtitle: "+2 vs last week",
      icon: <UserPlus className="w-4 h-4 text-gray-600" />,
    },
    {
      title: "Qualified Leads",
      value: "27",
      subtitle: "32% of total",
      icon: <UserRoundCheck className="w-4 h-4 text-gray-600" />,
    },
    {
      title: "Lost Leads",
      value: "9",
      subtitle: "-2 vs last week",
      icon: <UserRoundX className="w-4 h-4 text-gray-600" />,
    },
  ];

  const leads = [
    {
      id: 1,
      name: "Rachel Scott",
      email: "rachel.scott@orbitsoft.com",
      phone: "+1-202-555-0143",
      channel: "Email",
      assignedTo: "Kevin",
      status: "Contacted",
      created: "Jul 03, 2025",
    },
    {
      id: 2,
      name: "Daniel Kim",
      email: "daniel.kim@cloudmerge.io",
      phone: "+1-202-555-0199",
      channel: "LinkedIn",
      assignedTo: "Unassigned",
      status: "New",
      created: "Jul 08, 2025",
    },
    {
      id: 3,
      name: "Lina Alvarez",
      email: "lina.alvarez@neotech.ai",
      phone: "+1-202-555-0187",
      channel: "Phone",
      assignedTo: "Nathanael",
      status: "Qualified",
      created: "Jul 01, 2025",
    },
    {
      id: 4,
      name: "Ben Foster",
      email: "ben.foster@blueline.co",
      phone: "+1-202-555-0123",
      channel: "Email",
      assignedTo: "Jordan",
      status: "Lost",
      created: "Jun 27, 2025",
    },
    {
      id: 5,
      name: "Jenna Malik",
      email: "jenna.malik@kanvas.io",
      phone: "+1-202-555-0174",
      channel: "Phone",
      assignedTo: "Kevin",
      status: "Qualified",
      created: "Jul 02, 2025",
    },
    {
      id: 6,
      name: "Ahmed Farouk",
      email: "ahmed.far@venturenow.com",
      phone: "+1-202-555-0168",
      channel: "Email",
      assignedTo: "Sophie",
      status: "Contacted",
      created: "Jul 03, 2025",
    },
    {
      id: 7,
      name: "Sophie Chan",
      email: "sophie.chan@novadesk.io",
      phone: "+1-202-555-0155",
      channel: "LinkedIn",
      assignedTo: "Unassigned",
      status: "New",
      created: "Jul 12, 2025",
    },
    {
      id: 8,
      name: "Marco Liu",
      email: "marco.liu@synera.ai",
      phone: "+1-202-555-0149",
      channel: "Phone",
      assignedTo: "Kevin",
      status: "Qualified",
      created: "Jul 10, 2025",
    },
    {
      id: 9,
      name: "Fatima Rahman",
      email: "fatima.rahman@bizworks.co",
      phone: "+1-202-555-0138",
      channel: "Email",
      assignedTo: "Jordan",
      status: "Lost",
      created: "Jun 05, 2025",
    },
    {
      id: 10,
      name: "Oliver Grant",
      email: "oliver.grant@sparkhive.com",
      phone: "+1-202-555-0110",
      channel: "LinkedIn",
      assignedTo: "Nathanael",
      status: "Qualified",
      created: "Jun 03, 2025",
    },
  ];

  const getStatusBadge = (status) => {
    const statusStyles = {
      Contacted: "bg-blue-100 text-blue-800 border border-blue-200",
      New: "bg-gray-100 text-gray-800 border border-gray-200",
      Qualified: "bg-green-100 text-green-800 border border-green-200",
      Lost: "bg-purple-100 text-purple-800 border border-purple-200",
    };

    return (
      <span
        className={`px-2 py-1 rounded-full text-xs font-medium ${statusStyles[status]}`}
      >
        {status}
      </span>
    );
  };

  function getInitials(name = "") {
    const words = name.trim().split(/\s+/);

    if (words.length === 1) {
      return words[0].slice(0, 2).toUpperCase();
    }

    if (words.length === 2) {
      return (words[0][0] + words[1][0]).toUpperCase();
    }

    return (words[0][0] + words[words.length - 1][0]).toUpperCase();
  }

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "25px",
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3500,
  };

  return (
    <MainLayout location={location} setLocation={setLocation}>
      <div className=" bg-gray-50">
        {/* Metrics Carousel */}
        <div className="mb-6">
          <Slider {...sliderSettings}>
            {metrics.map((card, index) => (
              <div key={index} className="px-2">
                <div className="bg-white p-4 rounded-xl border border-gray-200 shadow-md">
                  <div className="flex items-center gap-2 mb-2">
                    <div className="p-1.5 bg-gray-100 rounded-md">
                      {card.icon}
                    </div>
                    <span className="text-sm font-medium">{card.title}</span>
                  </div>
                  <div className="text-2xl text-gray-900">{card.value}</div>
                  <div className="text-xs text-gray-500">{card.subtitle}</div>
                </div>
              </div>
            ))}
          </Slider>
        </div>

        {/* Search & Actions */}
        <div className="bg-white rounded-lg border border-gray-200 mb-4 p-3">
          {/* Search Bar */}
          <div className="relative mb-3">
            <Search className="w-4 h-4 absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400" />
            <input
              type="text"
              placeholder="Search here..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full pl-8 pr-2 py-2 rounded-md border border-gray-300 bg-gray-50 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>

          {/* Action Buttons */}
          <div className="flex flex-wrap gap-2">
            <button className="flex-1 flex items-center justify-center gap-1 px-2 py-1 rounded-md bg-white border border-gray-300 text-xs shadow-sm">
              <Filter className="w-3 h-3 text-gray-600" />
              Filter
            </button>
            <button className="flex-1 flex items-center justify-center gap-1 px-2 py-1 rounded-md bg-white border border-gray-300 text-xs shadow-sm">
              <ArrowUpDown className="w-3 h-3 text-gray-600" />
              Sort
            </button>
            <button className="flex-1 flex items-center justify-center gap-1 px-2 py-1 rounded-md bg-white border border-gray-300 text-xs shadow-sm">
              <UserPlus className="w-3 h-3" />
              Add Customer
            </button>
            <button className="flex-1 flex items-center justify-center gap-1 px-2 py-1 rounded-md bg-white border border-gray-300 text-xs shadow-sm">
              <Download className="w-3 h-3 text-gray-600" />
              Export CSV
            </button>
          </div>
        </div>

        {/* Lead Cards */}
        <div className="space-y-3">
          {leads.map((lead) => (
            <div
              key={lead.id}
              className="bg-white rounded-lg border border-gray-200 p-4 flex flex-col justify-between"
            >
              <div>
                <div className="flex items-start justify-between mb-3">
                  <div className="flex-1">
                    <div className="flex items-center gap-2">
                      {/* Initials circle */}
                      <div className="w-7 h-7 flex items-center justify-center bg-gray-600 text-white rounded-full text-xs font-semibold">
                        {getInitials(lead.name)}
                      </div>

                      {/* Name */}
                      <div className="font-medium text-gray-900 text-sm">
                        {lead.name}
                      </div>
                    </div>
                    <div className="text-sm text-gray-600 mt-1">
                      {lead.email}
                    </div>
                  </div>
                  <div className="ml-3">{getStatusBadge(lead.status)}</div>
                </div>
              </div>
              <div className="flex justify-end mt-2 space-x-2">
                <button className="p-2 bg-gray-100 rounded-full active:bg-gray-300 transition-colors duration-150">
                  <Phone className="w-4 h-4 text-gray-600" />
                </button>
                <button className="p-2 bg-gray-100 rounded-full active:bg-gray-300 transition-colors duration-150">
                  <MessageSquare className="w-4 h-4 text-gray-600" />
                </button>
                <button className="p-2 bg-gray-100 rounded-full active:bg-gray-300 transition-colors duration-150">
                  <MoreVertical className="w-4 h-4 text-gray-600" />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </MainLayout>
  );
};

export default DesignReplicaMobile;
